import { render, staticRenderFns } from "./HeaderTeacher.vue?vue&type=template&id=fd76e078&"
import script from "./HeaderTeacher.vue?vue&type=script&lang=js&"
export * from "./HeaderTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports